export default __webpack_public_path__ + "static/media/Stevie.8bcde5da.png";